import { useContext, useEffect, useRef, useState } from "react";
import axios from "axios";
import Loader from "./Loader";
import NTreeItem from "./NTreeItem";
import { Droppable } from "react-beautiful-dnd";
import { api } from "../services/config";
import { ProjectContext } from "../screens/ProjectScreen";
import { useOutletContext } from "react-router-dom";
import { SemanticTreeContext } from "./SemanticTree";

function NTree({ id, hyponyms: hyponyms_, root, onListRef, pageChanged, setPageChanged }) {
    const {
        treeState, setTreeState,
    } = useContext(ProjectContext);

    const {
        semanticRoot, setSemanticRoot,
        splittedTree,
        setCount,
        page,
    } = useContext(SemanticTreeContext)

    const [state, setState] = useState();
    const [hyponyms, setHyponyms] = useState(hyponyms_)
    const [loading, setLoading] = useState(false);

    const { profileState } = useOutletContext();
    const { projectRole: { projectId } } = profileState

    const { semanticTarget, semanticSource, item, updatedSemantics } = treeState;
    const [refresh, setRefresh] = useState(false);
    const listRef = useRef(null);

    if (
        (semanticTarget || semanticSource)
        && ((root && (semanticTarget === 0 || semanticSource === 0))
            || (semanticTarget === id || semanticSource === id))
        && (!refresh || `${semanticTarget}${semanticSource}${item}` !== refresh)
    ) {
        setRefresh(`${semanticTarget}${semanticSource}${item}`);
    }

    if (
        ((root && updatedSemantics?.includes(0))
            || updatedSemantics?.includes(id))
        && (!refresh || `${updatedSemantics}${item}` !== refresh)
    ) {
        setRefresh(`${updatedSemantics}${item}`);
    }

    useEffect(() => {
        const rootFirstRun = root && semanticTarget !== 0 && semanticSource !== 0 && !updatedSemantics?.includes(0)
        if (rootFirstRun && !hyponyms) setLoading(true);
        async function fetchSC() {
            await axios
                .get(
                    root
                        ? `${api.project}${projectId}/sc/root?offset=${page * 100}&limit=100`
                        : `${api.project}${projectId}/sc/${id}/hyponyms?limit=1000`
                )
                .then((res) => {
                    if (root) {
                        if (!hyponyms) setSemanticRoot(res.data.classes);
                        else setHyponyms(res.data.classes);
                        setCount(res.data.count);
                        setLoading(false);

                        refresh && setTreeState({});
                        pageChanged && setPageChanged(false);
                    }
                    else setState(res.data.classes);
                })
                .catch(function (error) {
                    setLoading(false);
                    pageChanged && setPageChanged(false);
                    return Promise.reject(error);
                });
        }
        // INFO: Second condition to refresh searched path root 
        if (
            !hyponyms || pageChanged
            || (root && (semanticTarget === 0 || semanticSource === 0 || updatedSemantics?.includes(0)))
        ) fetchSC();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [id, hyponyms, refresh, page, pageChanged, setPageChanged]);

    useEffect(() => {
        hyponyms_ && setHyponyms(hyponyms_)
    }, [hyponyms_])

    useEffect(() => {
        if (listRef.current && typeof onListRef === "function") {
            onListRef(listRef?.current);
        }
    }, [listRef, onListRef]);

    return (
        <div
            className={`${root ? "semantic_tab__tree__root ml-4" : "tab-ml-3"}`}
        >
            <div
                className="semantic_tab__tree_items"
                ref={root ? listRef : null}
            >
                {root && (<>
                    <span className="mr-5 pl-0">
                        Racine
                    </span>
                    <Droppable droppableId={`{"itemId": ${0}, "type": "root", "splittedTree": ${splittedTree || false} }`}>
                        {(provided, snapshot) => (
                            <div
                                className={`ml-3 droppable-box-mini ${snapshot.isDraggingOver ? "dragging" : ""
                                    }`}
                                style={{
                                    borderBottom: snapshot.isDraggingOver
                                        ? "1px solid rgb(32, 82, 12)"
                                        : "",
                                }}
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                id="box-mini"
                            ></div>
                        )}
                    </Droppable>
                </>
                )}
                {!hyponyms &&
                    (loading
                        ? <div className="mt-5"><Loader /></div>
                        : (root ? semanticRoot : state)
                            ?.map((item) => <NTreeItem key={item.id} item={item} />)
                    )
                }
                {hyponyms?.map((item) => (
                    <NTreeItem key={item.id} item={item} />
                ))}
            </div>
        </div>
    );
}
export default NTree;
